import { createSlice } from "@reduxjs/toolkit";

export const logSlice = createSlice({
    name: "loglist",
    initialState: {
      loglists: [], 
      loading: false,
      error: null,
    },
    reducers: {
        setLoading: (state) => {
          state.loading = true;
          state.error = null; 
        },
        setLogList: (state, action) => {
          state.loading = false;
          state.error = null;
          state.loglists = action.payload.data; 
      },
        setError: (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }, 
      },
})

export const {
    setLoading,
    setLogList,
    setError,
  } = logSlice.actions;
  
  export default logSlice.reducer;

